/**
 * UTM persistence — capture campaign params on first visit, persist them for
 * the session, and copy them into the hidden utm_* inputs of every enquiry form
 * so attribution survives across Swup navigations (the global contact modal
 * lives outside #swup, so it must be re-hydrated per page like enquiry-context).
 *
 * Storage: sessionStorage — survives in-session navigation, clears when the tab
 * closes, and needs no cookie-consent gate. If cross-session (returning-visit)
 * attribution is required, swap to a first-party cookie with a TTL — HubSpot
 * already does cross-session attribution natively via the hutk cookie, so the
 * sessionStorage default deliberately avoids duplicating that.
 */
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'mh_utm';

/**
 * Read utm_* from the current URL; if any are present, persist the whole set.
 * Called on every hydrate — a navigation without params never clobbers a
 * previously-captured set.
 */
function captureUtm() {
    const params = new URLSearchParams(window.location.search);
    const captured = {};
    let found = false;
    UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) {
            captured[key] = value;
            found = true;
        }
    });
    if (found) {
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
        } catch {
            /* storage unavailable (private mode / disabled) — fail soft */
        }
    }
}

function getStoredUtm() {
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch {
        return {};
    }
}

/**
 * Capture (if landing with params) then copy the stored UTM set into the hidden
 * utm_* inputs of every enquiry form. Call on load and after each Swup nav.
 */
export function hydrateUtmFields() {
    captureUtm();
    const utm = getStoredUtm();
    if (!Object.keys(utm).length) return;

    document.querySelectorAll('form.mh-form').forEach((form) => {
        UTM_KEYS.forEach((key) => {
            const input = form.querySelector(`input[type="hidden"][name="${key}"]`);
            if (input && utm[key]) {
                input.value = utm[key];
            }
        });
    });
}
